export const productCards = () => {
  const $productCards = document.querySelectorAll(".product-card");
  $productCards.forEach(($productCard) => {
    // const productId = $productCard.dataset.productId;
    const variantId = $productCard.dataset.variantId;

    const $productCardImage = $productCard.querySelector(
      ".product-card__image"
    );
    // const $productCardQuickAdd = $productCard.querySelector(
    //   ".product-card__quick-add"
    // );
    // $productCardQuickAdd.addEventListener("click", async (event) => {
    //   event.preventDefault();
    //   const cart = window.Carbon.Cart;
    //   const response = await cart.quickAddItemToCart(variantId);
    //   if (response) {
    //     if (cart.useCartAside) {
    //       const $cartAsideBackground = document.querySelector(
    //         ".cart-aside__background"
    //       );
    //       const $cartAside =
    //         $cartAsideBackground.querySelector("aside.cart-aside");
    //       const $body = document.querySelector("body");
    //       $body.classList.add("overflow-y-hidden");
    //       $cartAsideBackground.classList.remove("pointer-events-none");
    //       $cartAsideBackground.classList.add("bg-black", "bg-opacity-40");
    //       $cartAside.classList.remove(
    //         "translate-x-full",
    //         "ponter-events-none",
    //         "hidden"
    //       );
    //     } else {
    //       const $navbarCart = document.querySelector(".nav__bar-cart");
    //       const $navbarCartImage = $navbarCart.querySelector(
    //         ".nav__bar-cart-image"
    //       );
    //       $navbarCartImage.src = $productCardImage.src;
    //       $navbarCart.classList.remove("opacity-0", "pointer-events-none");
    //       $navbarCart.classList.add("opacity-100");

    //       setTimeout(() => {
    //         $navbarCart.classList.remove("opacity-100");
    //         $navbarCart.classList.add("opacity-0", "pointer-events-none");
    //       }, 5000);
    //     }
    //   }
    // });
  });
};

export default productCards;
